import { useCallback, useEffect, useRef } from 'react';
import { useParamCompilationStore } from './hooks/store/useParamCompilationStore';
import { useSubscription } from './socket/useSubscription';

const TIMEOUT_MS = 30_000;

export const ParamCompilationTracker: React.FC = () => {
  const status = useParamCompilationStore(s => s.status);
  const compilationCompleted = useParamCompilationStore(s => s.compilationCompleted);
  const compilationTimedOut = useParamCompilationStore(s => s.compilationTimedOut);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useSubscription(
    { type: 'param-compilation-completed', skip: status !== 'compiling' },
    useCallback(() => {
      clearTimeout(timeoutRef.current);
      compilationCompleted();
    }, [compilationCompleted])
  );

  useEffect(() => {
    if (status === 'compiling') {
      timeoutRef.current = setTimeout(() => {
        compilationTimedOut();
      }, TIMEOUT_MS);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [status, compilationTimedOut]);

  return null;
};
